var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.deleteDocuments($event)}}},[_c('el-button',{attrs:{"type":"primary","native-type":"submit","loading":_vm.loading_submit}},[_vm._v("Eliminar documentos de prueba")])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49144bd8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/tenant/options/form.vue
// module id = gUul
// module chunks = 0